import { Sparkles, RefreshCw } from "lucide-react";

const LABELS = { tours_booked: "Tours booked (HubSpot)", tours_completed: "Tours that showed", won_deals: "Deals won", proposals_sent: "Proposals sent" };

export function CrmFillBanner({ info, loading, onFill, disabled }) {
  return (
    <div className="border border-brand-gold/40 bg-brand-gold/5 rounded-md px-4 py-3 space-y-2" data-testid="weekly-crm-banner">
      <div className="flex flex-wrap items-center gap-3">
        <Sparkles className="h-4 w-4 text-brand-gold shrink-0" />
        <p className="text-sm text-brand-ink flex-1 min-w-[220px]">
          {info ? "Pre-filled from the CRM — check the numbers, adjust anything that's off, then save to confirm."
            : "Pull this week's tours booked (from HubSpot), tours that showed and deals won (marked in the Hub)."}
        </p>
        <button onClick={onFill} disabled={disabled || loading} data-testid="weekly-crm-fill"
          className="inline-flex items-center gap-1.5 border border-brand-border rounded-full px-3 py-1 text-xs text-brand-ink bg-brand-surface hover:bg-brand-hover transition-colors disabled:opacity-50">
          <RefreshCw className={`h-3 w-3 ${loading ? "animate-spin" : ""}`} /> {loading ? "Pulling…" : info ? "Re-pull from CRM" : "Fill from CRM"}
        </button>
      </div>
      {info && (
        <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1 text-[11px] text-brand-muted" data-testid="weekly-crm-people">
          {Object.entries(LABELS).map(([k, label]) => (
            <p key={k}><span className="text-brand-tertiary">{label} ({info.people[k].length}):</span> {info.people[k].join(", ") || "none"}</p>
          ))}
        </div>
      )}
    </div>
  );
}

export function pendingWeeks(weeks, todayStr) {
  const have = new Set(weeks.map((w) => w.week_start));
  const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const out = [];
  const d = new Date(`${todayStr.slice(0, 7)}-01T00:00:00`);
  d.setDate(d.getDate() + ((8 - d.getDay()) % 7));
  const monthStart = todayStr.slice(0, 7);
  while (ymd(d).slice(0, 7) === monthStart && ymd(d) <= todayStr) {
    if (!have.has(ymd(d))) out.push(ymd(d));
    d.setDate(d.getDate() + 7);
  }
  return out;
}
